var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownDarkNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_74",
    "data-name": "Polygon 74",
    d: "M4,0,8,4H0Z",
    transform: "translate(8 4) rotate(-180)",
    fill: "#424647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownDarkNew);
export default __webpack_public_path__ + "static/media/dropdown-dark-new.0d0da33b.svg";
export { ForwardRef as ReactComponent };